import request from '@/router/axios'
import env from '@/config/env'

/**
 * 保存部门
 * @param {参数} params
 * @returns
 */
export const saveDepartment = (params) => {
  return request({
    url: `${env.officeUrl}/department/save`,
    method: 'POST',
    data: params,
  })
}

/**
 * 获取部门树
 * @param {参数} params
 * @returns
 */
export const getDepartmentTree = () => {
  return request({
    url: `${env.officeUrl}/department/tree/all`,
    method: 'GET',
  })
}

/**
 * 获取部门
 * @param {参数} params
 * @returns
 */
export const getDepartment = (params) => {
  return request({
    url: `${env.officeUrl}/department/${params}`,
    method: 'GET',
  })
}

/**
 * 删除部门
 * @param {参数} params
 * @returns
 */
export const delDepartment = (params) => {
  return request({
    url: `${env.officeUrl}/department/del`,
    method: 'DELETE',
    params,
  })
}

/**
 * 获取部门简单树
 * @param {参数} params
 * @returns
 */
export const getDepartmentSimpleTree = (params) => {
  return request({
    url: `${env.officeUrl}/department/tree/simple`,
    method: 'GET',
    params
  })
}
